import React from 'react';

import { Virtualize } from './VirtualizedAutocomplete';

import type { SxProps } from '@mui/material/styles';

export interface VirtualizedGroupedAutocompleteProps {
  value: string | null;
  options: string[];
  onChange: (value: string | null) => void | Promise<void>;
  styles?: SxProps;
  label?: string;
  loading?: boolean;
  loadingText?: string;
  error?: string;
  errorStyles?: SxProps;
  required?: boolean;
  innerRef?: React.RefObject<HTMLDivElement | null>;
  placeholder?: string;
  inputAutoComplete?: string;
  disablePortal?: boolean;
}

interface TemplateDetails {
  id: number;
  name: string;
}

type GroupedTemplates = [string, TemplateDetails[]][];

export const formatOptions = (options: GroupedTemplates): string[] =>
  options.flatMap(([groupName, templates]) =>
    templates.map((template) => `${template.id} - ${template.name}@-*@${groupName}`)
  );

const getDelimitedOptionLabel = (option: string) => option.split('@-*@')[0];

const getDelimitedOptionGroup = (option: string) => option.split('@-*@')[1] ?? '';

const VirtualizeGrouped = ({
  options,
  value,
  onChange,
  styles,
  error,
  errorStyles,
  loading,
  loadingText,
  label,
  required = false,
  innerRef,
  placeholder,
  inputAutoComplete,
  disablePortal = false
}: VirtualizedGroupedAutocompleteProps) => (
  <Virtualize
    dataTestId="virtualize-grouped"
    disablePortal={disablePortal}
    error={error}
    errorStyles={errorStyles}
    getOptionLabel={getDelimitedOptionLabel}
    groupBy={getDelimitedOptionGroup}
    innerRef={innerRef}
    inputAutoComplete={inputAutoComplete}
    label={label}
    loading={loading}
    loadingText={loadingText}
    onChange={onChange}
    options={options}
    placeholder={placeholder}
    required={required}
    styles={styles}
    value={value}
  />
);

export default VirtualizeGrouped;
